import { render } from "./BaseSpinner.vue?vue&type=template&id=1758a89a"
import script from "./BaseSpinner.vue?vue&type=script&lang=js"
export * from "./BaseSpinner.vue?vue&type=script&lang=js"
script.render = render

export default script